var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_38099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H8C10.2091 0 12 1.79086 12 4V16C12 18.2091 10.2091 20 8 20H0V0Z",
    fill: "#2D6E8D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 7,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 10,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 13,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 13,
    r: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_38099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragging);
export default __webpack_public_path__ + "static/media/dragging.f83a745f2ba0d9c901d4f5a0308171bd.svg";
export { ForwardRef as ReactComponent };